import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { Message } from '@patsnap/tahiti-core/common/message';
import type { VueI18n } from 'vue-i18n';
import { I18nService } from '@/services/i18n-service';
import { CheckSensitiveWord } from '@/infrastructure/api-functions/interface/check-sensitive-word.interface';

export const CheckSensitiveWordService = Symbol('CheckSensitiveWordService');

export interface CheckSensitiveWordService {
    checkSensitiveWord: (word: string) => Promise<string>;
}

@injectable()
export class CheckSensitiveWordServiceImpl implements CheckSensitiveWordService {
    constructor(
        @inject(Message)
        private _message: Message,
        @inject(I18nService)
        private _i18n: VueI18n,
        @inject(CheckSensitiveWord)
        private readonly _checkSensitiveWordApi: CheckSensitiveWord
    ) {
    }

    public async checkSensitiveWord(text: string) {
        if (!text) return Promise.resolve('');
        const res = await this._checkSensitiveWordApi.checkSensitiveWord({ tech_desc: text });
        const out = res.out;
        if (out) {
            this._message.closeAll();
            this._message.error({
                message: this._i18n.t('aiTranslation.sensitiveTip') as string,
                showClose: true,
            });
        }
        return out;
    }
}
